import { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';

//import components
import Breadcrumb from './../components/dynamic/Breadcrumb';
import ProductsComponent from '../components/dynamic/products/ProductsComponent' ;


//import locales
import { useTranslation } from "react-i18next";
import "../i18n";


//import api
import FetchData from "../api/Api";

export default function Search() {

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);

    //get locale
    const { t } = useTranslation();
    const { locale, slug } = useParams();

    //get data
    const [data, setData] = useState(null);
    const [grid, setGrid] = useState([3, 3, 6]);
    

    useEffect(() => {

        if (data === null) {
            const fetchData = async () => {
                try {
                    const fetchDataInstance = new FetchData();
                    await fetchDataInstance.initHeaders(locale);
                    const result = await fetchDataInstance.get(`/api/products?keyword=${searchParams.get('keyword')}`, true);
                    setData(result);
                } catch (error) {
                    console.error("Failed to get data:", error.message);
                }
            };

            setTimeout(function() {
                fetchData();
            }, 100)

            
        }

    }, [data, locale, slug, location]);

    useEffect(()=> {
        setData(null);
    }, [locale, slug, location])



    return (
        <>
            <Breadcrumb title={t('search')} url={`/${locale}/search?keyword=${searchParams.get('keyword')}`} />
            <div className='container mx-auto mt-10 px-3'>
                <div className="grid grid-cols-12 gap-5">
                    
                    <div className="col-span-12 gap-5 grid-cols-12">
                        <div className="col-span-12 gap-3 lg:gap-5 grid-cols-12 grid">
                            <ProductsComponent grid={grid} data={data} />
                        </div>
                    </div>
                </div>
            </div>
        </>
        
    );
}